<template>
  <div class="banner" :class="[{ index: from == 'index' }]">
    <div id="particles-js"></div>
    <div class="container">
      <a class="back" href="/"><i class="el-icon-arrow-left"></i>返回首页</a>
      <h1 class="welcome">Hi，欢迎使用中国数字文化链！</h1>
      <div class="search-input-wrapper">
        <div class="select-box">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              {{ curMenu ? curMenu.label : "请选择" }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in menuList"
                :key="item.id"
                :command="index"
                >{{ item.label }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="input-wrapper">
          <input
            type="text"
            :placeholder="
              curMenu && curMenu.id == 'evidence'
                ? '请输入存证ID/存证哈希'
                : '请输入查询内容'
            "
            v-model="key"
            @keyup.enter="getReuslt()"
          />
        </div>
        <div class="btn-search" @click.stop="getReuslt()">
          <i class="el-icon-search"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "search",
  props: {
    from: {
      type: String,
      default: ""
    },
    curType: {
      type: String,
      default: ""
    },
    curKey: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      screenWidth: 0,
      menuList: [
        { id: "goods_id", label: "商品ID" },
        { id: "trade_hash", label: "交易哈希" },
        { id: "origin_trade_hash", label: "原始哈希" },
        { id: "evidence", label: "存证查询" },
        { id: "addr", label: "账户地址" }
      ],
      curMenu: null,
      key: ""
    };
  },
  watch: {
    curType: {
      handler(val) {
        if (val) {
          this.curMenu = this.menuList.filter(item => {
            return item.id === val;
          })[0];
        } else {
          this.curMenu = null;
        }
      },
      immediate: true
    },
    curKey: {
      handler(val) {
        this.key = val;
      },
      immediate: true
    }
  },
  mounted() {
    // 获取屏幕尺寸
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  methods: {
    handleCommand(command) {
      this.curMenu = this.menuList[command];
    },
    getReuslt() {
      let { type, key } = this.$route.query;
      let routeName = this.$route.name;

      if (!this.curMenu) {
        this.$message.error("请选择查询类型");
        return;
      }
      if (!this.key) {
        this.$message.error("请输入查询内容");
        return;
      }
      if (this.curMenu.id === "goods_id" && !(this.key > 0)) {
        this.$message.error("查询内容不正确");
        return;
      }
      if (this.curMenu.id !== "goods_id" && this.key > 0) {
        this.$message.error("查询内容不正确,是否要查询商品ID?");
        return;
      }
      if (
        routeName === "search" &&
        type === this.curMenu.id &&
        key === this.key
      ) {
        this.$emit("searchKey", { type: this.curMenu.id, key: this.key });
        return;
      }
      this.$router.push(`search?type=${this.curMenu.id}&key=${this.key}`);
    }
  }
};
</script>
<style scoped>
.select-box .el-dropdown {
  height: 52px;
  line-height: 52px;
  color: #101010;
}
</style>
<style scoped>
.banner {
  position: relative;
  background-position: center;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-image: url("../assets/banner_bg_sm.png");
  height: 170px;
  overflow: hidden;
}
.banner::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 640px;
  height: 255px;
  background-image: url("../assets/banner_left.png");
  background-position: center;
  background-repeat: no-repeat;
}
.banner::after {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 696px;
  height: 170px;
  background-image: url("../assets/banner_right_sm.png");
  background-position: center;
  background-repeat: no-repeat;
}

#particles-js {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.banner .container {
  max-width: 1200px;
  position: relative;
  z-index: 1;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 35px 0;
  text-align: center;
}

.banner .back {
  display: none;
  margin-bottom: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #acc7f8;
  line-height: 17px;
  text-align: left;
  cursor: pointer;
}
.banner .back i {
  margin-right: 3px;
}

.banner .welcome {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 20px;
  color: #fff;
  line-height: 28px;
  text-align: left;
}

.banner .search-input-wrapper {
  max-width: 749px;
  height: 50px;
  padding: 0 1px;
  background: #fff;
  border-radius: 9px;
  border: 1px solid #e8eaf3;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-top: 16px;
  position: relative;
  /* box-shadow: 0px 4px 6px 0px rgba(40, 131, 255, 0.2); */
}

.banner .search-input-wrapper .select-box {
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;
  padding: 0 12px 0 15px;
  width: 112px;
}

.search-input-wrapper .select-box .el-dropdown {
  cursor: pointer;
}

.banner .search-input-wrapper .select-box::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -8.5px;
  width: 2px;
  height: 19px;
  background: #dee5eb;
}

.banner .search-input-wrapper .input-wrapper {
  width: 30%;
  flex-grow: 1;
  flex-shrink: 1;
}

.banner .search-input-wrapper input {
  flex: 1;
  background: none;
  font-size: 14px;
  color: #333;
  border: none;
  padding: 0 15px;
  width: 100%;
  box-sizing: border-box;
}

.banner .search-input-wrapper input:focus {
  outline: none;
}

.banner .search-input-wrapper ::-webkit-input-placeholder {
  color: #999;
}

.banner .search-input-wrapper ::-moz-placeholder {
  color: #999;
}

.banner .search-input-wrapper ::-ms-input-placeholder {
  color: #999;
}

.banner .btn-search {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1777ff;
  font-size: 20px;
  cursor: pointer;
  letter-spacing: 2px;
  background: #ffffff;
  border-radius: 0px 9px 9px 0px;
  border-left: 1px solid #e8eaf3;
}
.banner .btn-search .el-icon-search {
  font-weight: bold;
}

.banner.index {
  background-image: url("../assets/banner_bg.png");
  height: 360px;
}

.banner.index::after {
  height: 360px;
  background-image: url("../assets/banner_right.png");
}
.banner.index .back {
  display: block;
}
.banner.index .container {
  padding: 100px 0;
}

@media (max-width: 1199px) {
  .banner.index .container {
    padding: 100px 20px;
  }
  .banner .container {
    padding: 35px 20px;
  }
  .banner .title {
    font-size: 20px;
  }

  .banner .title.bold {
    margin-top: 5px;
    font-size: 28px;
  }

  .banner .search-input-wrapper .select-box {
    padding: 0 8px 0 10px;
    width: 104px;
  }

  .banner .btn-search {
    width: 58px;
    font-size: 18px;
  }
}

@media (max-width: 800px) {
  .banner::after {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue